import React from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ExtractionBatchNewModal from './ExtractionBatchNewModal';
import { AppContext } from '../../../App';
import { ITrainingSet, IExtractionBatch } from '../../../types/my-types';
import { UploadContext } from '../../upload/UploadContext';

export interface ExtractionBatchNewProps {
  extractionBatches: IExtractionBatch[];
  coreVersion: string;
}

const ExtractionBatchNew: React.FC<ExtractionBatchNewProps> = ({
  extractionBatches,
  coreVersion,
}) => {
  const {
    setLabel,
    setUploading,
    open,
    setOpen,
    setStep,
    setAcceptedDocs,
    setOption,
    updateTotalUploadedDocs,
    updateTotalAcceptedDocs,
    updateTotalFailedDocs,
  } = React.useContext(UploadContext);

  const [trainingSet, setTrainingSet] = React.useState<ITrainingSet>();

  // set default training set
  const setUploadingLS = (value: boolean) => {
    localStorage.setItem('uploading', value + '');
    setUploading(value);
  };

  const resetModal = () => {
    setUploadingLS(false);
    setTrainingSet(undefined);
    setAcceptedDocs([]);
    setLabel('');
    setStep(1);
    setOption(0);

    // to reset doc count for consecutive upload
    updateTotalUploadedDocs(0);
    updateTotalAcceptedDocs(0);
    updateTotalFailedDocs(0);
  };

  const dismissModal = () => {
    // To cancel uploads on pressing Cancel
    // TODO: is it possible to do without reload?
    // window.location.reload();

    resetModal();
    setOpen(false);
  };

  return (
    <>
      <Button
        data-cy="create-extraction-batch"
        startIcon={<AddIcon sx={{ fontSize: '16px !important' }} />}
        onClick={() => {
          resetModal();
          setOpen(true);
        }}
        sx={{
          height: 32,
          px: 1.5,
          borderRadius: '6px',
          border: '1px solid #1D9AAA',
          bgcolor: '#fff',
          fontSize: '12.5px',
          fontWeight: 500,
          color: '#1D9AAA',
          textTransform: 'none',
          '&:hover': {
            borderColor: '#178a99',
            bgcolor: 'rgba(29,154,170,0.04)',
          },
          '& .MuiButton-startIcon': { mr: 0.5 },
        }}
      >
        Create
      </Button>

      {open ? (
        <ExtractionBatchNewModal
          dismissModal={dismissModal}
          resetModal={resetModal}
          coreVersion={coreVersion}
          extractionBatches={extractionBatches}
          trainingSet={trainingSet}
          setTrainingSet={setTrainingSet}
        />
      ) : null}
    </>
  );
};

export default ExtractionBatchNew;
